import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const cockpitInterestedBuyersWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitInterestedBuyers',
    cols: 6,
    props: {
      title: 'cockpit_interested_buyers_widget_title',
      text: 'cockpit_interested_buyers_widget_detailed_text',
    },
  },
  {
    name: 'cockpitLostInterestWidget',
    cols: 6,
  },
  {
    name: 'cockpitRejectionReasonsGraphWidget',
    cols: 12,
    props: {
      title: 'cockpit_rejection_reasons_graph_title',
    },
  },
  {
    name: 'cockpitInterestedBuyersDetailWidget',
    cols: 12,
    props: {
      title: 'cockpit_interested_buyers_detail_title',
    },
  },
]);
